function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.78,
    height: 12.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.737142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 6.08
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.16,
    width: 23.78,
    height: 12.71,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9776923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 18.515
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.88,
    width: 23.78,
    height: 16.31,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2619999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 33.035
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.18,
    width: 23.78,
    height: 19.21,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.744285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 50.785
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.39,
    width: 23.78,
    height: 21.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 71.31
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.23,
    width: 23.78,
    height: 22.94,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8233333333333337
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 93.7
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105.17,
    width: 23.78,
    height: 25.57,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 117.955
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.74,
    width: 23.78,
    height: 25.57,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 143.525
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156.31,
    width: 23.78,
    height: 27.09,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.756
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 169.855
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 183.4,
    width: 23.78,
    height: 28.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3971428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 197.84
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.28,
    width: 23.78,
    height: 30.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.756
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 227.55
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 242.82,
    width: 23.78,
    height: 36.21,
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 260.925
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 279.03,
    width: 23.78,
    height: 37.31,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.926666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 297.68499999999995
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 316.35,
    width: 23.78,
    height: 39.8,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 336.25
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.15,
    width: 23.78,
    height: 40.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 376.395
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 396.64,
    width: 23.78,
    height: 40.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6422222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 416.885
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 437.14,
    width: 23.78,
    height: 41.46,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 457.87
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 478.6,
    width: 23.78,
    height: 42.98,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3971428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 500.09000000000003
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.58,
    width: 23.78,
    height: 43.53,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 543.345
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 565.11,
    width: 23.78,
    height: 43.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.378
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 587.015
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 608.92,
    width: 23.78,
    height: 43.81,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 630.8249999999999
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 652.73,
    width: 23.78,
    height: 47.27,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.378
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.89,
    y: 676.365
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 0,
    width: 33.38,
    height: 35.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.768571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.47,
    y: 17.72
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 0,
    width: 34.31,
    height: 35.44,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.315,
    y: 17.72
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.48,
    y: 0,
    width: 34.31,
    height: 35.44,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.635,
    y: 17.72
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.79,
    y: 0,
    width: 34.4,
    height: 35.44,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.99,
    y: 17.72
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.19,
    y: 0,
    width: 34.78,
    height: 35.44,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.968571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.57999999999998,
    y: 17.72
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.97,
    y: 0,
    width: 35.24,
    height: 35.44,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.034285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.59,
    y: 17.72
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.21,
    y: 0,
    width: 35.24,
    height: 35.44,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.034285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.83,
    y: 17.72
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.45,
    y: 0,
    width: 36.63,
    height: 35.44,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.062857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.765,
    y: 17.72
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.08,
    y: 0,
    width: 37.74,
    height: 35.44,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.95,
    y: 17.72
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.82,
    y: 0,
    width: 38.48,
    height: 35.44,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.087999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.06,
    y: 17.72
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.3,
    y: 0,
    width: 38.58,
    height: 35.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.59000000000003,
    y: 17.72
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.88,
    y: 0,
    width: 39.13,
    height: 35.44,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.445,
    y: 17.72
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.02,
    y: 0,
    width: 39.41,
    height: 35.44,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.72499999999997,
    y: 17.72
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.43,
    y: 0,
    width: 39.5,
    height: 35.44,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.087999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.1800000000001,
    y: 17.72
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.93,
    y: 0,
    width: 40.06,
    height: 35.44,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.087999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.9599999999999,
    y: 17.72
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.99,
    y: 0,
    width: 41.55,
    height: 35.44,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.087999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.765,
    y: 17.72
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.54,
    y: 0,
    width: 41.64,
    height: 35.44,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.36,
    y: 17.72
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 658.18,
    y: 0,
    width: 41.82,
    height: 35.44,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.062857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.0899999999999,
    y: 17.72
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 35.44,
    width: 41.81,
    height: 35.68,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.097142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 53.28
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 71.12,
    width: 41.81,
    height: 36.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.215999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 89.16
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 107.2,
    width: 41.81,
    height: 37.02,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.170000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 125.71000000000001
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 144.22,
    width: 41.81,
    height: 37.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.436
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 162.81
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 181.4,
    width: 41.81,
    height: 37.33,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.465999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 200.065
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 218.73,
    width: 41.81,
    height: 37.41,
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.67625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 237.435
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 256.15,
    width: 41.81,
    height: 37.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.367142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 274.935
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 293.72,
    width: 41.81,
    height: 38.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.353333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 312.78000000000003
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 331.84,
    width: 41.81,
    height: 38.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.82375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 351.135
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 370.43,
    width: 41.81,
    height: 40.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.715714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 390.435
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 410.44,
    width: 41.81,
    height: 40.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.715714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 430.445
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 450.45,
    width: 41.81,
    height: 40.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 470.455
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 490.45,
    width: 41.81,
    height: 40.24,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.748571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 510.57
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 530.7,
    width: 41.81,
    height: 41.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.268
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 551.37
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 572.04,
    width: 41.81,
    height: 41.58,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 592.8299999999999
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 613.62,
    width: 41.81,
    height: 43.07,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.972857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 635.155
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 656.69,
    width: 41.81,
    height: 43.31,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.972857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.685,
    y: 678.345
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 35.44,
    width: 42.51,
    height: 42.59,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.501999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.845,
    y: 56.735
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.11,
    y: 35.44,
    width: 42.75,
    height: 42.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.485,
    y: 56.735
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.86,
    y: 35.44,
    width: 43.44,
    height: 42.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.6475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.58,
    y: 56.735
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.3,
    y: 35.44,
    width: 43.44,
    height: 42.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.259
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.02,
    y: 56.735
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.74,
    y: 35.44,
    width: 44.14,
    height: 42.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.32375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.81,
    y: 56.735
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.87,
    y: 35.44,
    width: 44.37,
    height: 42.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.055,
    y: 56.735
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.24,
    y: 35.44,
    width: 44.98,
    height: 42.59,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.73,
    y: 56.735
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.22,
    y: 35.44,
    width: 45.14,
    height: 42.59,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.32375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.79,
    y: 56.735
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.36,
    y: 35.44,
    width: 45.29,
    height: 42.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.005,
    y: 56.735
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.65,
    y: 35.44,
    width: 46.91,
    height: 42.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.6475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.10499999999996,
    y: 56.735
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 35.44,
    width: 46.91,
    height: 42.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.025,
    y: 56.735
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.48,
    y: 35.44,
    width: 46.91,
    height: 42.59,
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.9350000000001,
    y: 56.735
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.39,
    y: 35.44,
    width: 48.3,
    height: 42.59,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.54,
    y: 56.735
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.7,
    y: 35.44,
    width: 49.3,
    height: 42.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.35,
    y: 56.735
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 78.03,
    width: 46.28,
    height: 45.66,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.132
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 100.86
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 123.7,
    width: 46.28,
    height: 45.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.609999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 146.53
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 169.36,
    width: 46.28,
    height: 45.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.554285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 192.3
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 215.24,
    width: 46.28,
    height: 46.02,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 238.25
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 261.26,
    width: 46.28,
    height: 46.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.256
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 284.485
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 307.7,
    width: 46.28,
    height: 46.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.713333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 330.995
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 354.29,
    width: 46.28,
    height: 47.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 377.975
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 401.66,
    width: 46.28,
    height: 47.79,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.713333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 425.555
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 449.45,
    width: 46.28,
    height: 48.36,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.611428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 473.63
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 497.82,
    width: 46.28,
    height: 48.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 522.285
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 546.75,
    width: 46.28,
    height: 49.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.713333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 571.675
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 596.6,
    width: 46.28,
    height: 51.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.142222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 622.38
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 648.16,
    width: 46.28,
    height: 51.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.73,
    y: 674.0799999999999
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 78.03,
    width: 48.6,
    height: 50.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.942857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.17000000000002,
    y: 103.08500000000001
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.47,
    y: 78.03,
    width: 49.05,
    height: 50.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.13125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.995,
    y: 103.08500000000001
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.52,
    y: 78.03,
    width: 49.97,
    height: 50.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.138571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 234.505,
    y: 103.08500000000001
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.49,
    y: 78.03,
    width: 50.83,
    height: 50.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.26375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.90500000000003,
    y: 103.08500000000001
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.32,
    y: 78.03,
    width: 52.73,
    height: 50.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.685,
    y: 103.08500000000001
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.05,
    y: 78.03,
    width: 53.84,
    height: 50.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.97,
    y: 103.08500000000001
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.89,
    y: 78.03,
    width: 55.09,
    height: 50.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.435,
    y: 103.08500000000001
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.98,
    y: 78.03,
    width: 55.35,
    height: 50.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.567777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.65500000000003,
    y: 103.08500000000001
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.33,
    y: 78.03,
    width: 56.33,
    height: 50.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.495,
    y: 103.08500000000001
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.66,
    y: 78.03,
    width: 58.1,
    height: 50.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.011
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.7099999999999,
    y: 103.08500000000001
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.76,
    y: 78.03,
    width: 58.24,
    height: 50.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.88,
    y: 103.08500000000001
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 128.15,
    width: 56.6,
    height: 52.2,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 154.25
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 180.35,
    width: 56.6,
    height: 52.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.481428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 206.535
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 232.72,
    width: 56.6,
    height: 53.36,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.928888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 259.4
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 286.08,
    width: 56.6,
    height: 53.42,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.903333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 312.78999999999996
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 339.49,
    width: 56.6,
    height: 56.55,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.078571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 367.765
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 396.05,
    width: 56.6,
    height: 58.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 425.40000000000003
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 454.75,
    width: 56.6,
    height: 59.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 484.275
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 513.8,
    width: 56.6,
    height: 59.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 543.7299999999999
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 573.66,
    width: 56.6,
    height: 62.36,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 604.8399999999999
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 636.02,
    width: 56.6,
    height: 63.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.17000000000002,
    y: 668.01
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 128.15,
    width: 56.28,
    height: 64.58,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.62,
    y: 160.44
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.76,
    y: 128.15,
    width: 56.79,
    height: 64.58,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.1975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.155,
    y: 160.44
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.55,
    y: 128.15,
    width: 56.94,
    height: 64.58,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.388
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.02,
    y: 160.44
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.49,
    y: 128.15,
    width: 57.35,
    height: 64.58,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.165,
    y: 160.44
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.84,
    y: 128.15,
    width: 57.45,
    height: 64.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.383333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.565,
    y: 160.44
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.3,
    y: 128.15,
    width: 58.16,
    height: 64.58,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.693333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.38,
    y: 160.44
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.46,
    y: 128.15,
    width: 61.47,
    height: 64.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.1949999999999,
    y: 160.44
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.93,
    y: 128.15,
    width: 63.36,
    height: 64.58,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.6099999999999,
    y: 160.44
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.29,
    y: 128.15,
    width: 63.71,
    height: 64.58,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.371
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.145,
    y: 160.44
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 192.73,
    width: 67.01,
    height: 61.94,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.323333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 223.7
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 254.68,
    width: 67.01,
    height: 62.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.877142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 285.75
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 316.82,
    width: 67.01,
    height: 62.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.982857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 348.26
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 379.69,
    width: 67.01,
    height: 63.32,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 411.35
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 443.01,
    width: 67.01,
    height: 63.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 474.74
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 506.47,
    width: 67.01,
    height: 63.66,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 538.3000000000001
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 570.13,
    width: 67.01,
    height: 64.35,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 602.305
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 634.48,
    width: 67.01,
    height: 65.52,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.98499999999999,
    y: 667.24
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 192.73,
    width: 62.86,
    height: 70.37,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.92,
    y: 227.915
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.35,
    y: 192.73,
    width: 64.08,
    height: 70.37,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.39000000000004,
    y: 227.915
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.43,
    y: 192.73,
    width: 65.43,
    height: 70.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.145,
    y: 227.915
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.86,
    y: 192.73,
    width: 65.52,
    height: 70.37,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.62,
    y: 227.915
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.38,
    y: 192.73,
    width: 66.97,
    height: 70.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.161666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.865,
    y: 227.915
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.36,
    y: 192.73,
    width: 68.79,
    height: 70.37,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.755,
    y: 227.915
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.15,
    y: 192.73,
    width: 70.85,
    height: 70.37,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.052857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.5749999999999,
    y: 227.915
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 263.1,
    width: 70.68,
    height: 71.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.097142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.83000000000004,
    y: 298.625
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 334.15,
    width: 70.68,
    height: 71.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.835
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.83000000000004,
    y: 370.09499999999997
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 406.04,
    width: 70.68,
    height: 72.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.097142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.83000000000004,
    y: 442.17
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 478.3,
    width: 70.68,
    height: 72.4,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.83000000000004,
    y: 514.5
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 550.69,
    width: 70.68,
    height: 73.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.780000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.83000000000004,
    y: 587.4000000000001
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 624.11,
    width: 70.68,
    height: 75.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.780000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.83000000000004,
    y: 662.0550000000001
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.17,
    y: 263.1,
    width: 78,
    height: 68.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.835714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.17,
    y: 297.52500000000003
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.17,
    y: 263.1,
    width: 78.1,
    height: 68.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.22,
    y: 297.52500000000003
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.27,
    y: 263.1,
    width: 78.38,
    height: 68.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.46,
    y: 297.52500000000003
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.65,
    y: 263.1,
    width: 79.34,
    height: 68.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.3199999999999,
    y: 297.52500000000003
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.99,
    y: 263.1,
    width: 80.01,
    height: 68.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.995,
    y: 297.52500000000003
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.17,
    y: 331.95,
    width: 88.76,
    height: 62.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.55,
    y: 363.09
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.17,
    y: 394.23,
    width: 88.76,
    height: 66.39,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.278
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.55,
    y: 427.425
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.17,
    y: 460.62,
    width: 88.76,
    height: 67.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5488888888888885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.55,
    y: 494.59000000000003
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.17,
    y: 528.56,
    width: 88.76,
    height: 85.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.55,
    y: 571.1949999999999
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.17,
    y: 613.84,
    width: 88.76,
    height: 86.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.55,
    y: 656.9200000000001
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.93,
    y: 331.95,
    width: 98.35,
    height: 80.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.105,
    y: 372.315
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.28,
    y: 331.95,
    width: 101.28,
    height: 80.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.92,
    y: 372.315
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.56,
    y: 331.95,
    width: 105.44,
    height: 80.73,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.28,
    y: 372.315
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.93,
    y: 412.68,
    width: 94.87,
    height: 91.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.299999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.365,
    y: 458.58
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.93,
    y: 504.48,
    width: 94.87,
    height: 96.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.85875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.365,
    y: 552.72
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.93,
    y: 600.96,
    width: 94.87,
    height: 99.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.552857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.365,
    y: 650.48
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.8,
    y: 412.68,
    width: 79.2,
    height: 131.42,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.4,
    y: 478.39
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 412.68,
    width: 131,
    height: 131.42,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.714285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.5,
    y: 478.39
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.8,
    y: 544.1,
    width: 210.2,
    height: 155.9,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.983333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.9,
    y: 622.0500000000001
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920);
export default __webpack_public_path__ + "static/media/1920.fb6fb12ed051b231031c404d51771806.svg";
export { ForwardRef as ReactComponent };